import React from "react";
import { IoBookmark } from "react-icons/io5";
import { useNavigate, useParams } from "react-router-dom";
import { dataDefaultFetch, getDataAPI } from "../../utils/fetchData";
import { message } from "antd";
import parse from "html-react-parser";
import BannerFiForPage from "../../components/_shared/ui-blocks/BannerFiForPage";
import * as dayjs from "dayjs";
import HelmetContents from "../../components/Head";
import LoadingContents from "../../components/_shared/LoadingContents";

export default function BlogDetails() {
  const [onePro, setOnePro] = React.useState(dataDefaultFetch);

  const { title } = useParams();
  const navigate = useNavigate();

  if (!title || onePro.error) {
    navigate("/blog");
    message.error("Can not access!");
  }

  React.useEffect(() => {
    if (title) {
      (async () => {
        setOnePro({ ...onePro, loading: true });
        try {
          const res = await getDataAPI(`blog/one/${title}`);

          setOnePro({ ...onePro, data: res.data?.data, loading: false });
        } catch (error) {
          setOnePro({ ...onePro, data: null, loading: false, error: error });
        }
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title]);

  return (
    <>
      <BannerFiForPage title={"Blog"} titleOtherF={true} />
      <HelmetContents
        title={onePro.data?.title}
        description={onePro.data?.short_content}
        imageUrl={onePro.data?.img.url}
        canonicalUrl={`/blog/${onePro.data?.slug}`}
        imageAlt={`sunflower-tours-hg-${onePro.data?.title}-image`}
        type="article"
        DynamicMetas={[
          {
            property: "article:author",
            content: onePro.data?.created_by,
          },
          {
            property: "article:published_time",
            content: onePro.data?.createdAt,
          },
        ]}
      />

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Article",
          headline: onePro.data?.title,
          description: onePro.data?.short_content,
          image: onePro.data?.img.url,
          author: {
            "@type": "Person",
            name: "Sunflower Ha Giang",
            email: "info.hgmotorbiketours@gmail.com",
          },
          datePublished: new Date(onePro.data?.createdAt).toLocaleString(),
          dateModified: new Date(onePro.data?.updatedAt).toLocaleString(),
        })}
      </script>
      {onePro.data ? (
        <>
          <div className="wrapBlogDel container">
            <div className="ct-inf">
              <div className="tabhead">
                <IoBookmark />
                <p>{onePro.data?.categories}</p>
              </div>
              <div className="in">
                <p>{onePro.data?.created_by}</p>
                <p>{dayjs(onePro.data?.createdAt).format("DD/MM/YYYY")}</p>
              </div>
            </div>

            <h1>{onePro.data?.title}</h1>

            <div className="desc">
              <div>
                <img src={onePro.data?.img.url} alt={onePro.data?.img.name} />
              </div>
              {parse(onePro.data?.desc)}
            </div>
          </div>
        </>
      ) : (
        <div className="wrapBlogDel container">
          <LoadingContents />
        </div>
      )}
    </>
  );
}
